import { KEY_COMPONENT_NAME } from './variable';
export default {
  name: KEY_COMPONENT_NAME,
  echart: ['common', 'map', 'pictorialbar', 'wordcloud', 'scatter', 'bar', 'line', 'pie', 'gauge', 'funnel', 'radar']
};
